var t={top:{top:0}},e={left:{left:2}};export{e as legendHorizontalWrapperStyleConfig,t as legendVerticalWrapperStyleConfig};
